<template>
  <v-card class="mb-4">
    <v-toolbar dense>
      <v-toolbar-title>
        APC History
      </v-toolbar-title>
      <v-spacer />
      <cert-edit-button
        :personid="personId"
        :create-new="true"
        v-if="personId"
        @save="loadcerts"
        :disabled="!currentUserCan('editCerts')"
      />
      <v-btn icon @click="loadcerts">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <div v-if="errors.length > 0">
      <v-alert v-for="message in errors" :key="message" type="error">
        {{ message }}
      </v-alert>
    </div>
    <v-data-table
      dense
      :items="certs"
      :headers="tableHeaders"
      item-key="practicingcertificateid"
      :loading="loading"
      :options.sync="options"
    >
      <template v-slot:item="props">
        <tr>
          <td>
            {{
              lookup("PracticingCertificateType", props.item.certificatetypeid)
            }}
          </td>
          <td>
            <v-icon v-if="!props.item.active">remove</v-icon>
            <v-icon color="success" v-else>check</v-icon>
          </td>
          <td>{{ props.item.startdate | formatDate }}</td>
          <td>
            {{ props.item.expirydate | formatDate }}
          </td>
          <td>{{ props.item.datecreated | formatDate }}</td>
          <td>{{ props.item.practicingcertificateid }}</td>
          <td>
            <cert-edit-button
              :cert="props.item"
              @save="loadcerts"
              :disabled="!currentUserCan('editCerts')"
            />
            <delete-item-button
              url="practicingcertificates"
              :itemid="props.item.practicingcertificateid"
              @delete="loadcerts"
              :disabled="!currentUserCan('editCerts')"
            ></delete-item-button>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import certEditButton from "./edit-cert-button";
import deleteItemButton from "@/components/lib/delete-item-button";

export default {
  name: "certList",
  data() {
    return {
      person: {},
      practitioner: {},
      scopesofpractice: [],
      apc: [],
      qualifications: [],
      // certs: [],
      errors: [],

      options: {
        sortDesc: [true],
        sortBy: ["startdate"],
        itemsPerPage: 5
      },
      tableHeaders: [
        { text: "Type", value: "certificatetypeid" },
        { text: "Active?", value: "active" },
        { text: "Start", value: "startdate" },
        { text: "Expiry", value: "expirydate" },
        { text: "Created", value: "datecreated" },
        { text: "ID", value: "practicingcertificateid" },
        { text: "", width: "156px" }
      ],
      openEditCertDialog: false
    };
  },
  methods: {
    async loadcerts() {
      if (!this.personId) {
        return;
      }

      await this.$store.dispatch("load", this.personId);
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  computed: {
    ...mapGetters({ lookup: "lookup", loading: "isLoading" }),
    certs() {
      const person = this.$store.getters.getById(this.personId);
      return person?.practitioner?.certificates;
    }
  },
  props: {
    personId: [Number, String]
  },
  watch: {
    personId: {
      handler: "loadcerts",
      immediate: true
    }
  },
  filters: {
    currency(amount) {
      return "$" + amount;
    }
  },
  components: {
    certEditButton,
    deleteItemButton
  }
};
</script>
